// extracted by mini-css-extract-plugin
module.exports =  {"light":"light--c6u9t"};